import React from 'react';
import ReactDOM from 'react-dom';

import Main from './components/Main';

import './ui/index.scss';

ReactDOM.render(<Main />, document.getElementById('root'));
